import { $http } from "@/utils/http";
import { translation } from "@/helpers/translation";
import { globalLoader } from "@/helpers/variables/index";

import {
    SET_ALL_PAGES,
    SET_CATALOG_MENU,
    SET_CATALOG_MENU_LOADING,
    SET_LIST_CATEGORY_FILTERS,
    SET_LIST_CATEGORY_FILTERS_LOADING,
    SET_SEO_DATA,
    SET_TRANSLATIONS,
    SET_WARNING_STATUS,
    SHOW_NEED_CONSULTATION,
    SHOW_NOT_LEAVE_POPUP,
} from "../mutation-types";

import {
    GET_ALL_PAGES,
    GET_CATEGORIES_MENU,
    GET_CATEGORY_FILTERS,
    GET_SEO_DATA,
    GET_TRANSLATIONS,
} from "../action-types";

const state = {
    menu: null,
    config: null,
    configLoading: false,
    menuLoading: false,
    translations: null,
    filterCategories: null,
    filterCategoriesLoading: false,
    warningStatus: false,
    showNotLeavePopup: false,
    showNeedConsultation: false,
    allPagesList: "",
    seoData: "",
};

const getters = {
    seoData: state => state.seoData,
    allPagesList: state => state.allPagesList,
    filterCategories: state => state.filterCategories,
    filterCategoriesLoading: state => state.filterCategoriesLoading,
    menu: state => state.menu,
    translations: state => state.translations,
    config: state => state.config,
    configLoading: state => state.configLoading,
    warningStatus: state => state.warningStatus,
    showNotLeavePopup: state => state.showNotLeavePopup,
    showNeedConsultation: state => state.showNeedConsultation,
};

const actions = {
    [GET_SEO_DATA]: async ({ commit }, slug) => {
        globalLoader(true);
        try {
            const response = await $http.get(`v1/pages/${slug}`);
            commit(SET_SEO_DATA, response.data.data);
            return response;
        } catch (e) {
            throw e;
        } finally {
            globalLoader(false);
        }
    },

    [GET_ALL_PAGES]: async ({ commit }) => {
        globalLoader(true);
        try {
            const response = await $http.get("v1/pages");
            commit(SET_ALL_PAGES, response.data.data);
            return response;
        } catch (e) {
            throw e;
        } finally {
            globalLoader(false);
        }
    },
    [GET_TRANSLATIONS]: async ({ commit }, langKey) => {
        globalLoader(true);
        try {
            const response = await $http.get("v1/translations");
            let result = Object.assign(response.data, translation[langKey]);
            commit(SET_TRANSLATIONS, result);
            return result;
        } catch (e) {
            throw e;
        } finally {
            globalLoader(false);
        }
    },
    [GET_CATEGORY_FILTERS]: async ({ commit }, payload) => {
        commit(SET_LIST_CATEGORY_FILTERS_LOADING, true);
        try {
            const response = await $http.get(`v1/catalog/get-filters/${payload.categorySlug}`);
            commit(SET_LIST_CATEGORY_FILTERS, response.data);
            return response.data;
        } catch (e) {
            throw e;
        } finally {
            commit(SET_LIST_CATEGORY_FILTERS_LOADING, false);
        }
    },
    // [GET_PRICE_FILTER]: async ({commit}, payload) => {
    //     commit(SET_LIST_CATEGORY_FILTERS_LOADING, true);
    //     try {
    //         const response = await $http.get(`v1/catalog/get-filters/${payload.categorySlug}`);
    //         commit(SET_LIST_CATEGORY_FILTERS, response.data);
    //     } catch (e) {
    //         throw e;
    //     } finally {
    //         commit(SET_LIST_CATEGORY_FILTERS_LOADING, false);
    //     }
    // },
    [GET_CATEGORIES_MENU]: async ({ commit }) => {
        globalLoader(true);
        commit(SET_CATALOG_MENU_LOADING, true);
        try {
            const response = await $http.get("v1/categories");
            commit(SET_CATALOG_MENU, response.data.data);
        } catch (e) {
            throw e;
        } finally {
            globalLoader(false);
            commit(SET_CATALOG_MENU_LOADING, false);
        }
    },
};

const mutations = {
    [SET_WARNING_STATUS](state, status) {
        state.warningStatus = status;
    },
    [SET_LIST_CATEGORY_FILTERS](state, list) {
        state.filterCategories = list;
    },
    [SET_LIST_CATEGORY_FILTERS_LOADING](state, status) {
        state.filterCategoriesLoading = status;
    },
    [SET_TRANSLATIONS](state, status) {
        state.translations = status;
    },
    [SET_CATALOG_MENU_LOADING](state, status) {
        state.menuLoading = status;
    },
    [SET_CATALOG_MENU](state, config) {
        state.menu = config;
    },
    [SHOW_NOT_LEAVE_POPUP](state, status) {
        return
        state.showNotLeavePopup = status;
    },
    [SHOW_NEED_CONSULTATION](state, status) {
        state.showNeedConsultation = status;
    },
    [SET_ALL_PAGES](state, data) {
        state.allPagesList = data;
    },
    [SET_SEO_DATA](state, data) {
        state.seoData = data;
    },
};

export default {
    state,
    getters,
    actions,
    mutations,
};
